import { useEffect, useState } from 'react'
import axios from 'axios'
import constants from '../../constants/constants'

export const useAuth = () => {
  const [authData, setAuthData] = useState(null)

  useEffect(() => {
    const fetchAuthSession = async () => {
      try {
        const { data } = await axios.post(constants.api.auth.session)
        setAuthData(data)
      } catch (err) {
        setAuthData(null)
      }
    }
    fetchAuthSession()
  }, [])

  return authData
}
